<template>
    <div class="modal__time_list_row_item cursor_pointer" :class="classActive" @click.prevent="clickTime">
        <div class="modal__time_list_row_item_text">
            {{ timeText }}
        </div>
    </div>

</template>

<script>
export default {
    name: "modal_time_item",
    props: {
        selTime: {
            type: Object,
            required: true,
        }
    },
    emits: ['select_time'],
    methods: {
        clickTime() {
            EventBus.$emit('click_time', this.selTime);
        }
    },
    computed: {
        classActive(){
            if(this.selTime.isSelect){
                return {'active': true};
            }
            return {'active': false};
        },
        timeText() {
            if (this.selTime.time) {
                return this.selTime.time;
            }
            return '';
        }
    }
}
</script>
